
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { blockUi, unBlockUi } from '../../../../actions/actionCreator';
// utils
import { Translations } from '../../../../utils';
// constant
import { FORM_REFS } from '../../../../constants';
// restClient
import { eapiClient } from '../../../../restClient';
// children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';

class CreateNewProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      showProductName: 'false'
    };
    this.productLookUp = {
      'hsbc-net': 'echannels',
      'hsbc-connect': 'echannels',
      'hsbc-connect-to-sap': 'echannels',
      'swift': 'echannels',
      'account': 'accounts',
      'notional-pool': 'glses',
      'cash-concentration': 'glses',
      'interest-enhancement': 'glses'
    }
    this.locationState = props.history.location.state;
  }

  getFormData = (formData) => {
    this.setState({ formData });
  }

  getFormData = (formData) => {
    this.setState({ formData });
  }

  getPayload = (requestData) => {
    let activationDate = this.state.formData["Dateactivated"]
    var caseHistoryEventTriggerCheck = this.locationState.currentProduct !== undefined ? this.locationState.currentProduct.Dateactivated !== activationDate : true;
    if (activationDate !== undefined && caseHistoryEventTriggerCheck) {
      activationDate = new Date(activationDate).getTime();
      requestData = {
        ...requestData,
        activationDate: activationDate
      }
    }

    let closeDate = this.state.formData["Dateclosed"];
    if (closeDate !== undefined && closeDate !== null) {
      closeDate = new Date(closeDate).getTime();
      requestData = {
        ...requestData,
        closeDate: closeDate
      }
    }

    if (this.state.formData["productType"].value === "ach-credit") {
      requestData = {
        product: {
          ...requestData,
          achAgent: {
            name: this.props.case.registeredName,
            value: this.props.case.caseId
          }
        }
      }
    } else if (this.state.formData["productType"].value === "corporate-card") {
      requestData = {
        product: {
          ...requestData,
          corporateCardAgent: {
            name: this.props.case.registeredName,
            value: this.props.case.caseId
          }
        }
      }
    } else if (this.state.formData["productType"].value === "hsbc-net"
      || this.state.formData["productType"].value === "hsbc-connect"
      || this.state.formData["productType"].value === "hsbc-connect-to-sap" || this.state.formData["productType"].value === "swift") {
      requestData = {
        ...requestData,
        newEchannel: this.state.formData["id"] === undefined && true,
        profileOwner: {
          name: this.props.case.registeredName,
          value: this.props.case.caseId
        },
        eChannelType: {
          name: (this.state.formData["csProductType"] || this.state.formData["productType"]).name,
          value: this.state.formData["productType"].value
        }
      }
    } else if (this.state.formData["productType"].value === "account") {
      requestData = {
        ...requestData,
        accountHolder: {
          name: this.props.case.registeredName,
          value: this.props.case.caseId
        }
      }
    } else if (this.state.formData["productType"].value === "cs-other-product") {
      requestData = {
        product: {
          ...requestData,
          otherProductValue: this.state.formData["otherProductValue"],
          productAgent: {
            name: this.props.case.registeredName,
            value: this.props.case.caseId
          }
        }
      }
    } else if (this.state.formData["productType"].value === "notional-pool") {
      requestData = {
        ...requestData,
        glsProductType: {
          name: "Notional Pooling",
          value: "notional-pool"
        },
        glsAgent: {
          name: this.props.case.registeredName,
          value: this.props.case.caseId
        },
        notionalPooling: {},
        location: this.state.formData["country"],
      }
    } else if (this.state.formData["productType"].value === "cash-concentration") {
      requestData = {
        ...requestData,
        glsProductType: {
          name: "Cash Concentration",
          value: "cashcon"
        },
        glsAgent: {
          name: this.props.case.registeredName,
          value: this.props.case.caseId
        },
        cashConcentration: {}
      }
    } else if (this.state.formData["productType"].value === "interest-enhancement") {
      requestData = {
        ...requestData,
        glsProductType: {
          name: "Interest Enhancement",
          value: "interest"
        },
        glsAgent: {
          name: this.props.case.registeredName,
          value: this.props.case.caseId
        },
        interestEnhancement: {}
      }
    } else {
      requestData = {
        product: {
          ...requestData,
          productAgent: {
            name: this.props.case.registeredName,
            value: this.props.case.caseId
          }
        }
      }
    }
    return requestData;
  }

  onFormSubmit = () => {
    this.props.blockUi();
    var requestData = {
      csProductType: this.state.formData["csProductType"] || this.state.formData["productType"],
      productType: this.state.formData["productType"].value,
      csResidency: this.state.formData["csResidency"],
      caseId: this.props.case.caseId,
      country: this.state.formData["country"],
      profileId: this.state.formData["profileId"],
      productId: this.state.formData["productId"],
      clientSphereProduct: true,
      csProductStatus: this.state.formData["status"],
      accountNumber: this.state.formData["accountNumber"],
      branchCode: this.state.formData["branchCode"],
    }

    let countryValue = this.state.formData["otherCountryValue"];
    if (requestData.country.name === 'Other') {
      requestData.otherCountryValue = countryValue;
    }
    let payload = this.getPayload(requestData);
    var productType = this.productLookUp[this.state.formData["productType"].value] || this.state.formData["productType"].value;

    var METHOD = this.locationState.mode !== undefined && this.locationState.mode !== "edit" ? 'POST' : 'PUT';
    let apiURL;
    if (METHOD === 'PUT') {
      apiURL = '/product/' + productType + '/' + this.state.formData["id"] + '/clientSphere';
    }
    if (METHOD === 'POST') {
      apiURL = '/product/' + productType + '/clientSphere';
    }
    eapiClient(apiURL, {
      method: METHOD,
      data: JSON.stringify(payload)
    })
      .then(({ data }) => {
        this.props.history.goBack();
      })
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups() {
    let formData;
    if (this.locationState.currentProduct !== undefined) {
      formData = { ...this.locationState.currentProduct };
    } else {
      formData = {};
    }
    const properties = {
      formData,
      editType: 'product-requests-form',
      pathname: this.props.history.location.pathname
    };
    if (this.locationState.pageJson !== undefined && this.locationState.pageJson.aemform_ManualCaseProductRequests !== undefined) {
      return (
        <Dynamicform
          mode={this.locationState.mode}
          properties={properties}
          hideButtons={false}
          url={FORM_REFS[this.locationState.pageJson.aemform_ManualCaseProductRequests.formRef]}
          getFormData={this.getFormData}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
          saveButton={true}
          disableSubmitOnClick={false}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
          flag={this.props.lang.currentLangFlag.flag}
          productType="manual-case-add-product"
        />
      );
    }
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render() {
    const pageTitle = this.locationState.pageJson ? this.locationState.pageJson.static_text_ProductRequests : '';
    const containerCss = classnames("create-new-product", {
      "padding-40": !this.props.history.location.pathname.includes("/admin-panel/")
    });

    const divStyle = { padding: '20px 15px 3px 20px', background: '#fff' };
    const formContainerStyle = { margin: '30px' }; const formTitleStyle = { margin: '18px' };
    const formMarginStyle = { margin: '15px' };
    return (
      <div style={divStyle} className={containerCss}>
        <div className="form-container">
          <div className="form-title">
            <h2 style={formMarginStyle} className="form-heading" >{this.translations(pageTitle.text)}</h2>
          </div>
          {this.renderFormGroups()}
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state, props) => {
  return {
    lang: state.lang,
    case: state.newManualCase
  }
}

const mapDispatchToProps = dispatch => {
  return {
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    },
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(CreateNewProduct);



// WEBPACK FOOTER //
// ./src/components/Admin/CaseBody/SubComp/CreateNewProduct.js